module.exports = __webpack_public_path__ + "static/media/notification_closed.457a62c0.svg";